import { OWListenerDelegate, OWListener } from './common';

type LoginStateChangedEvent = overwolf.profile.LoginStateChangedEvent;

// -----------------------------------------------------------------------------
export interface OWProfileListenerDelegate extends OWListenerDelegate {
  onLoginStateChanged?(info: LoginStateChangedEvent);
}

// -----------------------------------------------------------------------------
export class OWProfileListener extends OWListener<OWProfileListenerDelegate> {
  // ---------------------------------------------------------------------------
  constructor(delegate: OWProfileListenerDelegate) {
    super(delegate);
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    super.start();
    overwolf.profile
            .onLoginStateChanged
            .addListener(this.onLoginStateChanged);
  }

  // ---------------------------------------------------------------------------
  public stop(): void {
    overwolf.profile
            .onLoginStateChanged
            .removeListener(this.onLoginStateChanged);
  }

  // ---------------------------------------------------------------------------
  private onLoginStateChanged = (info: LoginStateChangedEvent) => {
    if (!this._delegate.onLoginStateChanged) {
      return;
    }

    this._delegate.onLoginStateChanged(info);
  }
}
